import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

export const planTour: TourDef = {
  id: 'plan',
  steps: [
    { element: a('forecast-chart'), popover: { title: 'Your balance ahead', description: 'Built from today’s balances, scheduled transactions, budgets and goal contributions. The lowest point is marked.' } },
    { element: a('forecast-horizon'), popover: { title: 'How far ahead', description: 'Look 3 to 24 months out.' } },
    { element: a('forecast-scenario'), popover: { title: 'What if', description: 'Add a one-off or regular item, or drop a bill, and compare against your current path.' } },
    { element: a('forecast-bills'), popover: { title: 'Bills coming up', description: 'The next 30 days of scheduled items.' } },
  ],
};
